import React from 'react'
import Cheongdam from '@components/brand-cheongdam'

const CheongdamPage = () => {
  return <Cheongdam />
}

export default CheongdamPage
